import React from 'react'

import { Box } from '@mui/material'
import TrattamentiForm from './TrattamentiForm'
import { useSelector } from 'react-redux'



export const TerreniTrattamentiSlider = ({ cantine, setCantine }) => {
    const singleData = useSelector((store) => store.trattamenti.singleTrattamenti)
    console.log(singleData, "datasingletrer")

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una trattamento</h2>
            </Box>
            <TrattamentiForm
                cantine={cantine} setCantine={setCantine} singleData={singleData} table={"edit"} />
        </Box>
    )
}
